module.exports = __webpack_public_path__ + "4eb93ba49324dd0b8577fc5fb2cc8a85.png";